import Button from '../../components/commons/button'
import icEdit04Primary from '../../assets/images/ic-edit-04-primary.svg'
import icTrash01Red from '../../assets/images/ic-trash-01-red.svg'
import { ACTION_TYPE } from '../../constants/constant'

export const TABLE_PAYROLL_NOTES = {
    name: 'Payroll Notes',
    column: [
        {
            name: 'Department',
            key: 'department',
            className: 'font-semibold capitalize',
            classNameHeader: "!min-w-[200px] w-[200px]",
            render: ({ value }) => value?.name || '-',
        },
        {
            name: 'Division',
            key: 'division',
            className: 'font-semibold capitalize',
            classNameHeader: "!min-w-[200px] w-[200px]",
            render: ({ value }) => value?.name || '-',
        },
        {
            name: 'Notes',
            key: 'note',
            className: 'w-full',
            render: ({ value }) => <div className='whitespace-pre-line'>{value || '-'}</div>,
        },
        {
            name: 'Action',
            key: 'action',
            classNameHeader: '!text-center',
            render: ({ item, onClickItem }) => (
                <div className='flex space-x-3 justify-center'>
                    <Button
                        type='outline'
                        icon={icEdit04Primary}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                    />
                    <Button
                        type='danger'
                        icon={icTrash01Red}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
            ),
        },
    ],
}

export const INITIAL_DATA_QUERY_NOTES = {
    page: 1,
    limit: 20,
    search: '',
}
